import React, { useEffect, useRef } from 'react';

const Carousel = ({ images, reverse, onImageClick}) => {
  const trackRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;

    if (!track) return;

    let pos = 0;
    let startTime = null;

    const speed = 30; // pixels per second
    const direction = reverse ? -1 : 1;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const delta = (timestamp - startTime) / 1000;
      startTime = timestamp;

      pos += speed * delta * direction;

      // Reset position seamlessly
      if (direction === 1 && pos >= track.scrollHeight / 2) {
        pos = 0;
      } else if (direction === -1 && pos <= 0) {
        pos = track.scrollHeight / 2;
      }

      track.style.transform = `translateY(${-pos}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationRef.current);
  }, [images, reverse]);

  return (
    <div className="carousel">
      <div className="carousel-track" ref={trackRef}>
        {[...images, ...images].map((img, idx) => (
          <img
            key={idx}
            src={img}
            className="card"
            alt=""
            onClick={() => onImageClick && onImageClick(img)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
